<template>
  <div class="midautumn-team-page">
    <div v-wechat-title="'新春开局，胜天半子'"></div>

    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="autoOpenOS"
      v-on:loginSuccess="loginSuccess"
      @selectCallback="loginCallback"
      channelTips="角色UID可在游戏中—设置—UID查看"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:logoutCallback="osCancell"
      @noRole="noRole"
      @getSelectInfo="getSelectInfo"
      :gameName="gameName"
    ></Os>
    <!-- 头部 -->
    <Header
      v-if="true"
      :config="headerConfig"
      :isShowInfo="true"
      :isOnline="1"
      :downloadApp="downloadApp"
    />
    <!-- 内容 -->
    <div class="active-page">
      <div class="section-container">
        <div class="section section1">
          <div class="banner-bg"></div>
          <div class="banner"></div>

          <div class="team-consumption-box" id="team-consumption-box">
            <div
              :class="userInfo.game_id === 26 ? 'team_title_gzf' : 'team_title'"
            ></div>
            <div class="my-team">
              <div
                class="detail-btn"
                data-snail-report-name="组队消费-详情按钮"
                @click="showPopup('teamDetailShow')"
              ></div>
              <div
                :class="userInfo.game_id === 26 ? 'date_gzf' : 'date_1'"
              ></div>
              <div class="team-consumption-content">
                <div class="member-num">
                  队伍人数:【{{ memberNum }}/6】
                  <div
                    v-if="isActiveAppointment && userInfo.user_id && memberNum"
                    class="exit-btn"
                    @click="showPopup('teamExitShow')"
                  ></div>
                </div>
                <div class="member-list">
                  <ul>
                    <li v-for="(item, idx) in teamList" :key="idx">
                      <div
                        v-if="item.id"
                        :class="'player-info'"
                        @click="readPlayerInfo(item.id)"
                      >
                        <div
                          :class="idx % 2 == 0 ? 'avatar1' : 'avatar2'"
                        ></div>
                        <div :class="idx % 2 == 0 ? 'name1' : 'name2'">
                          {{ item.nick_name }}
                        </div>
                        <div class="icon_wrap">
                          <div v-if="item.is_kick_out" class="out"></div>
                          <div v-if="item.is_myself" class="me"></div>
                          <div v-if="item.is_first" class="captain"></div>
                          <div
                            :class="
                              item.status === 2
                                ? 'flyback'
                                : item.status === 3
                                ? 'new'
                                : ''
                            "
                          ></div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="player-info empty-seat"
                          data-snail-report-name="组队付费-邀请好友"
                          @click="onTeamShare()"
                        ></div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  :class="userInfo.game_id === 26 ? 'tips_gzf' : 'tips'"
                ></div>
                <div v-if="memberNum === 6" class="full-capacity-btn"></div>
                <div
                  v-else
                  class="invitation-btn"
                  data-snail-report-name="组队付费-邀请好友"
                  @click="onTeamShare()"
                ></div>
              </div>
            </div>

            <div
              :class="
                userInfo.game_id === 26
                  ? 'consumption-points-box1'
                  : 'consumption-points-box'
              "
            >
              <div class="account_info">
                <div
                  :class="userInfo.account ? 'login' : 'nologin'"
                  @click="showLogin()"
                ></div>
                <div class="name" v-if="userInfo.account">
                  【{{ userInfo.nick_name }}】
                </div>
                <div class="points">小组累计落子:{{ teamScore || 0 }}</div>
                <div class="tips" @click="showLogDialog()"></div>
              </div>
              <!-- 达成的奖励里程 -->
              <div
                :class="teamScore >= item ? 'count' + item : ''"
                v-for="item in countList"
                :key="item"
              >
                <div class="tick1"></div>
                <div class="tick2"></div>
                <div class="content"></div>
              </div>
              <div
                :class="teamScore >= item ? 'reach' + item : ''"
                v-for="(item, index) in countList"
                :key="index"
              >
                <div class="small_white1"></div>
                <div class="small_white2"></div>
                <div class="small_white3"></div>
                <div class="small_black"></div>
              </div>
              <div class="count_btn" @click="showPopup('countAwardShow')"></div>
              <div class="count_bg">{{ surplusCount }}/17</div>
              <div :class="scheduleClass()">
                <div class="line">
                  <img
                    src="../../../../assets/images/active/snail/springFestival/2/line.png"
                    alt=""
                    :style="{
                      width:
                        teamScore <= 100000
                          ? (teamScore / scheduleLevel) * 100 + '%'
                          : '100%',
                    }"
                  />
                </div>
                <div class="schedule_count">
                  {{ teamScore }}/{{ scheduleLevel }}
                </div>
              </div>
              <div
                :class="isEgg ? 'easter_egg' : 'easter_egg'"
                @click="triggerEffect"
              >
                <canvas
                  ref="apngCanvas"
                  width="86"
                  height="125"
                  v-show="isEgg"
                ></canvas>
              </div>
              <div class="gotoGc" @click="toRecharge()"></div>
            </div>
          </div>
          <div class="hgwj-tips" v-if="userInfo.game_id != 26"></div>
          <div class="activity_award"></div>
          <div class="more_active">
            <div class="active_title"></div>
            <div class="active_main">
              <div class="regress" @click="regressToActivity()"></div>
              <div class="lantern_show" @click="lightToActivity()"></div>
            </div>
          </div>

          <!-- 组队消费分享 -->
          <div class="hide-team-share-box" ref="teamImageDom">
            <img
              src="../../../../assets/images/active/snail/springFestival/dialog/share.png"
            />
            <div class="share-img">
              <div class="qrcode-box">
                <div id="team-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invite_icon" @click="showPopup('findTeamShow')"></div>
    </div>

    <!-- 组队消费弹窗组 -->

    <!-- 组队消费——角色二次确认弹窗 -->
    <div
      class="team-bind-role-confirm-wrap popup_wrap"
      v-show="teamBindRoleConfirmShow"
    >
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="team-bind-role-confirm-box popup_wrap-box"
          v-show="teamBindRoleConfirmShow"
        >
          <div class="tips">
            <p>[{{ selectedRoleInfo.server_name }}]</p>
            <p class="name">{{ selectedRoleInfo.role_name }}</p>
          </div>
          <div class="btn-box">
            <div
              class="btn confirm-btn"
              data-snail-report-name="组队消费-二次确认绑定角色"
              @click="confirmBindRole()"
            ></div>
            <div
              class="btn cancel-btn"
              data-snail-report-name="组队消费-二次取消绑定角色"
              @click="closeReConfirmBindRole()"
            ></div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 角色选择 -->
    <div class="snail-role-select-wrap popup_wrap" v-show="snailRoleSelect">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="snail-role-select-box popup_wrap-box"
          v-show="snailRoleSelect"
        >
          <div class="option-box">
            <div class="input">
              <select
                v-model="selectedRoleID"
                @focus="inputFocus()"
                @focusout="inputFocusOut()"
              >
                <option value="">请选择区组</option>
                <option
                  v-for="(item, index) in roleList"
                  :key="index"
                  :value="item.role_id"
                >
                  <span>{{
                    "区服:" +
                    item.server_name +
                    " 综合实力:" +
                    (item.extra && item.extra.score)
                  }}</span>
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input
                type="text"
                name=""
                readonly
                v-model="roleName"
                placeholder="请选择角色"
                @focus="inputFocus()"
                @focusout="inputFocusOut()"
              />
            </div>
          </div>
          <div class="btn-box">
            <div
              class="cancel-btn"
              data-snail-report-name="组队消费-取消绑定角色"
              @click="closePopup('snailRoleSelect')"
            ></div>
            <div
              class="confirm-btn"
              data-snail-report-name="组队消费-确认绑定角色"
              @click="reConfirmBindRolePopup()"
            ></div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 组队消费——微信分享 -->
    <div class="team-wechat-share-wrap popup_wrap" v-show="teamWechatShareShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="team-wechat-share-box popup_wrap-box"
          v-show="teamWechatShareShow"
        ></div>
      </transition>
      <div
        class="close-bg"
        v-show="teamWechatShareShow"
        @click="closeWechatShare('teamWechatShareShow')"
      ></div>
    </div>
    <!-- 组队消费——分享弹窗 -->
    <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="team-share-box popup_wrap-box"
          v-show="teamNotWechatShareShow"
        >
          <img :src="teamShareImg" alt="分享图片" />
          <div class="share-tips"></div>
          <!-- <button
            class="monitor-btn"
            @click="onCopy('team-clipboard-btn')"
            id="team-clipboard-btn"
            data-snail-report-name="付费活动弹窗-复制链接"
            data-event="复制邀请链接"
            :data-clipboard-text="teamShareCopy.linkText + teamShareLink"
          ></button> -->
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="teamNotWechatShareShow"
        @click="closePopup('teamNotWechatShareShow')"
      ></div>
    </div>

    <div>
      <!-- 组队消费——详情弹窗 -->
      <div class="team-detail-wrap popup_wrap" v-show="teamDetailShow">
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div class="team-detail-box popup_wrap-box" v-show="teamDetailShow">
            <div class="detail-content" v-if="teamDetailShow">
              <img
                src="../../../../assets/images/active/snail/springFestival/dialog/team-rule.png"
                alt=""
              />
            </div>
            <div class="gotoGc" @click="closePopup('teamDetailShow')"></div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamDetailShow"
          @click="closePopup('teamDetailShow')"
        ></div>
      </div>
      <!-- 组队消费——玩家被踢出队伍提示弹窗 -->
      <div
        class="team-player-kick-out-tip-wrap popup_wrap"
        v-show="teamKickOutTipShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-player-kick-out-tip-box popup_wrap-box"
            v-show="teamKickOutTipShow"
          >
            <div class="btn-box">
              <div
                class="btn confirm-btn"
                @click="closePopup('teamKickOutTipShow')"
              ></div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 组队消费——玩家信息 -->
      <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow">
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-player-info-box popup_wrap-box"
            v-show="teamPlayerInfoShow"
          >
            <div class="player-info">
              <div class="top">
                <div class="avatar-box">
                  <!-- <img class="avatar" :src="curPlayerInfo.pic" alt="" /> -->
                  <div class="name">{{ curPlayerInfo.nick_name || "" }}</div>
                </div>
              </div>

              <div class="info">
                <div class="row">
                  <div class="label">上次登录时间：</div>
                  <div class="value">
                    {{ `${curPlayerInfo.lastTime || ""}` }}
                  </div>
                </div>
                <div class="row">
                  <div class="label">贡献落子数：</div>
                  <div class="value">
                    {{
                      isActiveAppointment ? 0 : Number(curPlayerInfo.score) + 20
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
              <div
                class="btn confirm-btn"
                @click="closePopup('teamPlayerInfoShow')"
              ></div>
              <div class="btn" v-if="curPlayerInfo.is_kick_out">
                <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                  <span>倒计时:{{ kickOutSeconds }}秒</span>
                </div>
                <div v-else class="kick-out-btn" @click="onKickOut()"></div>
              </div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamPlayerInfoShow"
          @click="closePopup('teamPlayerInfoShow')"
        ></div>
      </div>
      <!-- 组队消费——玩家退出队伍弹窗 -->
      <div class="team-exit-wrap popup_wrap" v-show="teamExitShow">
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div class="team-exit-box popup_wrap-box" v-show="teamExitShow">
            <div class="tips">当前队伍人数：{{ memberNum }}人</div>
            <div class="btn-box">
              <div
                class="btn cancel-btn"
                @click="closePopup('teamExitShow')"
              ></div>
              <div
                class="btn confirm-btn"
                data-snail-report-name="退出队伍弹窗-确认退出"
                @click="onExitTeam()"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamExitShow"
          @click="closePopup('teamExitShow')"
        ></div>
      </div>
      <!-- 组队消费——积分记录弹窗 -->
      <div
        class="team-points-record-wrap popup_wrap"
        v-show="teamPointsRecordShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-points-record-box popup_wrap-box"
            v-show="teamPointsRecordShow"
          >
            <div class="record-box">
              <ul>
                <li v-for="(item, idx) of scoreList" :key="idx">
                  <div class="left">
                    <div class="name">
                      {{ item.remark
                      }}{{
                        item.type === 3
                          ? "充值获得落子数" + item.score
                          : item.score
                      }}
                    </div>
                  </div>
                  <div class="right">
                    <div class="date">
                      {{ item.time }}
                    </div>
                  </div>
                  <div class="line"></div>
                </li>
              </ul>
            </div>

            <div class="tips" @click="toRecharge()"></div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamPointsRecordShow"
          @click="closePopup('teamPointsRecordShow')"
        ></div>
      </div>
      <!-- 组队消费——积分记录弹窗 无积分 -->
      <div
        class="team-not-points-record-wrap popup_wrap"
        v-show="teamNotPointsRecordShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-not-points-record-box popup_wrap-box"
            v-show="teamNotPointsRecordShow"
          >
            <div class="btn-box">
              <div
                class="btn confirm-btn"
                data-snail-report-name="组队付费-获取积分"
                @click="toRecharge()"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamNotPointsRecordShow"
          @click="closePopup('teamNotPointsRecordShow')"
        ></div>
      </div>
      <!-- 组队消费——入队失败(满员) -->
      <div
        class="team-join-failed-full-strength-wrap popup_wrap"
        v-show="teamJoinFailedFullStrengthShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-join-failed-full-strength-box popup_wrap-box"
            v-show="teamJoinFailedFullStrengthShow"
          >
            <div class="btn-box">
              <div
                class="btn other-active-btn"
                @click="toIndex('teamJoinFailedFullStrengthShow')"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamJoinFailedFullStrengthShow"
          @click="closePopup('teamJoinFailedFullStrengthShow')"
        ></div>
      </div>
      <!-- 组队消费——入队失败(已有队伍) -->
      <div
        class="team-join-failed-has-team-wrap popup_wrap"
        v-show="teamJoinFailedHasTeamShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-join-failed-has-team-box popup_wrap-box"
            v-show="teamJoinFailedHasTeamShow"
          >
            <div class="btn-box">
              <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
              <div
                class="btn other-active-btn"
                @click="toIndex('teamJoinFailedHasTeamShow')"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamJoinFailedHasTeamShow"
          @click="closePopup('teamJoinFailedHasTeamShow')"
        ></div>
      </div>
      <!-- 组队消费——入队失败(自己邀请自己) -->
      <div
        class="team-join-failed-myself-wrap popup_wrap"
        v-show="teamJoinFailedMyselfShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-join-failed-myself-box popup_wrap-box"
            v-show="teamJoinFailedMyselfShow"
          >
            <div class="btn-box">
              <div
                class="btn other-active-btn"
                @click="toIndex('teamJoinFailedMyselfShow')"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamJoinFailedMyselfShow"
          @click="closePopup('teamJoinFailedMyselfShow')"
        ></div>
      </div>
      <!-- 组队消费——被邀请入队弹窗 -->
      <div
        class="team-invitation-join-wrap popup_wrap"
        v-show="teamInvitationJoinShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-invitation-join-box popup_wrap-box"
            v-show="teamInvitationJoinShow"
          >
            <div class="team-info">
              <p>
                当前小队人数:<span>{{
                  teamInvitationNum === 0 ? 1 : teamInvitationNum
                }}</span
                >人
              </p>
              <p>
                剩余<span>{{
                  teamInvitationNum === 0
                    ? 5
                    : Math.max(6 - teamInvitationNum, 0)
                }}</span
                >个空位
              </p>
            </div>
            <div class="btn-box">
              <div
                class="btn reject-btn"
                data-snail-report-name="组队消费-拒绝入队"
                @click="rejectJoinTeam()"
              ></div>
              <div
                class="btn agree-btn"
                data-snail-report-name="组队消费-立即入队"
                @click="agreeJoinTeam()"
              ></div>
            </div>
            <div
              :class="userInfo.game_id === 26 ? 'join-tip-gzf' : 'join-tip-zsf'"
              v-if="isActiveAppointment"
            ></div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamInvitationJoinShow"
          @click="closePopup('teamInvitationJoinShow')"
        ></div>
      </div>

      <!-- 正式活动期组队消费——邀请入队二次确认弹窗 -->
      <div
        class="team-invitation-confirm-wrap popup_wrap"
        v-show="teamInvitationConfirmShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="team-invitation-confirm-box popup_wrap-box"
            v-show="teamInvitationConfirmShow"
          >
            <div
              class="title"
              :class="isActiveAppointment ? 'appoint_gzf' : ''"
              v-if="userInfo.game_id === 26"
            ></div>
            <div
              class="title"
              :class="isActiveAppointment ? 'appoint_zsf' : ''"
              v-else
            ></div>
            <div class="team-info">
              <p>
                当前小队人数：{{
                  teamInvitationNum === 0 ? 1 : teamInvitationNum
                }}
              </p>
              <p>
                剩余空位：{{
                  teamInvitationNum === 0
                    ? 5
                    : Math.max(6 - teamInvitationNum, 0)
                }}
              </p>
              <p v-if="!isActiveAppointment">
                小队累计落子数：{{ teamTotalScore || 0 }}
              </p>
            </div>
            <div class="btn-box">
              <div
                class="btn cancel-btn"
                data-snail-report-name="组队消费-二次确认拒绝入队"
                @click="rejectJoinTeam()"
              ></div>
              <div
                class="btn confirm-btn"
                data-snail-report-name="组队消费-二次确认确定入队"
                @click="agreeJoinTeam()"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="teamInvitationConfirmShow"
          @click="closePopup('teamInvitationConfirmShow')"
        ></div>
      </div>
    </div>

    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div
              class="btn qq-btn"
              data-snail-report-name="寻找搭子弹窗-去QQ"
              @click="toGroupOfQQ()"
            ></div>
            <div
              class="btn wechat-btn"
              data-snail-report-name="寻找搭子弹窗-去微信"
              @click="toGroupOfWechat()"
            ></div>
          </div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="findTeamShow"
        @click="closePopup('findTeamShow')"
      ></div>
    </div>

    <!-- 组队满员提示 -->
    <div class="full_commission popup_wrap" v-show="fullCommissionShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div
          class="full_commission-box popup_wrap-box"
          v-show="fullCommissionShow"
        >
          <div class="btn" @click="closeShowFullCommission()"></div>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="fullCommissionShow"
        @click="closeShowFullCommission()"
      ></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button
            class="monitor-btn"
            @click="onCopy('qq-clipboard-btn')"
            id="qq-clipboard-btn"
            data-snail-report-name="复制QQ群号"
            data-event="复制QQ群号"
            :data-clipboard-text="qqNumber"
          ></button>
        </div>
      </transition>
      <div
        class="close-bg"
        v-show="qqGroupShow"
        @click="closePopup('qqGroupShow')"
      ></div>
    </div>

    <!-- 奖励弹窗组 -->
    <div>
      <!-- 奖励弹窗——谢礼详情 -->
      <div
        class="activity-benefits-wrap popup_wrap"
        v-show="activityBenefitsShow"
      >
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div
            class="activity-benefits-box popup_wrap-box"
            v-show="activityBenefitsShow"
          >
            <div class="btn-box">
              <div
                class="btn close-btn"
                @click="closePopup('activityBenefitsShow')"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="activityBenefitsShow"
          @click="closePopup('activityBenefitsShow')"
        ></div>
      </div>
      <!-- 奖励弹窗——充值轮次奖励 -->
      <div class="count-award-wrap popup_wrap" v-show="countAwardShow">
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div class="count-award-box popup_wrap-box" v-show="countAwardShow">
            <div class="count_content">
              <img
                src="../../../../assets/images/active/snail/springFestival/dialog/count_content.png"
                alt=""
              />
            </div>
            <div class="btn-box">
              <div
                class="btn close-btn"
                @click="closePopup('countAwardShow')"
              ></div>
            </div>
          </div>
        </transition>
        <div
          class="close-bg"
          v-show="countAwardShow"
          @click="closePopup('countAwardShow')"
        ></div>
      </div>
      <!-- 彩蛋弹窗弹窗 -->
      <div class="easter_egg-pop popup_wrap" v-show="easterEggShow">
        <transition
          enter-active-class="animated zoomInNew"
          leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }"
        >
          <div class="success-box popup_wrap-box" v-show="easterEggShow">
            <div class="btn" @click="easterEggShow = false"></div>
          </div>
        </transition>
      </div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import { GetRoleList } from "@/api/os";
import Os from "../os";
import Login from "@/components/login";
import Header from "../Header/index.vue";
import Footer from "@/components/Footer";
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from "../headerConfig";
import {
  onGetInitDataAPI,
  teamInitAPI,
  teamKickAPI,
  teamExitAPI,
  teamRewardAPI,
  teamJoinAPI,
} from "../api";
import { getRandomString, wechatBrowser } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
import QCJumpAuthPlugin from "@qcplay/jump-auth";
import parseAPNG from "apng-js";

const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: "MidAutumnTeamActive",
  components: {
    Os,
    Header,
    Footer,
    Login,
  },
  data() {
    return {
      headerConfig,
      gameName: "snail",
      downloadUrl: "http://snail.qingcigame.com/official/",
      rechargeUrl: "https://pay.qingcigame.com/pay?gameId=39",
      loginTypes: ["sms", "password"],
      autoOpenOS: true,
      preloadingShow: true,
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      teamShareCopy: {
        title: "",
        desc: "",
        linkText: "",
      },

      code: "",
      auth_code: "",
      friend_id: "",
      teamShareLink: "",
      teamShareImg: "",

      // 弹窗
      preventShow: false, // 全局遮罩
      snailRoleSelect: false, // 角色选择
      fullCommissionShow: false, // 组队满员提示
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群

      teamDetailShow: false, // 组队消费——详情弹窗
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamKickOutTipShow: false, // 组队消费——玩家被踢出队伍弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamBindRoleConfirmShow: false, // 组队消费——绑定角色确认弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗
      activityBenefitsShow: false, // 奖励弹窗——谢礼
      countAwardShow: false, // 奖励弹窗——充值轮次奖励
      easterEggShow: false, // 彩蛋弹窗

      teamActiveInfo: {},
      teamList: Array.from({ length: 6 }, () => ({})),
      packageList: Array.from({ length: 11 }, () => ({})),
      memberNum: 0,
      curPlayerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: true,

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期

      teamInvitationNum: 0,
      teamScore: 0,
      scoreList: [],
      selectedRoleInfo: {},
      qqNumber: "",
      qqLink: "",
      wechatLink: "",
      pageLink: "",
      isFront: true,
      teamTotalScore: 0,
      download_id: "",
      canGetReward: true,
      countList: [40, 80, 120, 150, 200, 300, 500, 750, 1000, 1500, 2000, 3000],
      isEgg: false, // 彩蛋动画
      clickEggCount: 0, // 点击彩蛋次数
      scheduleLevel: 4000, // 进度条等级
      surplusCount: 17, // 剩余奖励轮次
      player: null,
      imgSrc: require("@/assets/images/active/snail/springFestival/2/egg_animation.png"), // 确保图片路径正确
    };
  },
  created() {
    const targetDate = new Date("2026/02/06 4:59:59");
    // 获取当前时间
    const currentDate = new Date();
    // 计算时间差
    const timeDifference = targetDate - currentDate;
    // 如果时间差大于0，说明在预约期，否则不在预约期
    this.isActiveAppointment = timeDifference > 0 ? true : false;
    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("code");
    this.auth_code = urlParams.get("auth_code");
    this.friend_id = urlParams.get("friend_id");
    this.download_id = urlParams.get("download_id");
    const queryUA = urlParams.get("ua");
    const module = urlParams.get("module");

    urlParams.delete("code");
    urlParams.delete("auth_code");
    urlParams.delete("friend_id");
    urlParams.delete("module");
    urlParams.delete("ua");
    const newUrl =
      window.location.pathname +
      (urlParams.toString() ? "?" + urlParams.toString() : "");
    window.history.replaceState(null, "", newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({ length: 6 }, () => ({}));

    // 初始化
    this.onInitData(true);

    if (module === "team") {
      this.$nextTick(() => {
        this.scrollIntoTeamBox();
      });
    }
    if (queryUA === "snail") {
      this.rechargeUrl = `https://pay.qingcigame.com/pay?gameId=${this.userInfo.game_id}&ua=snail`;
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: "【最强蜗牛】蜗也要胜天半子！",
      imgUrl:
        "https://download4.qcplay.com/qcgame-api/mDG0FvkV2xtEH4cfyEIt8MMcWF6CxRo6IdrDiHzx.png",
      desc: "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
    });
  },
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    showComicImg: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    changeTab: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    showContent: {
      type: Boolean,
    },
    logger: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    document.addEventListener("click", this.handleGlobalClick, true);
    this.initAPNG();
  },
  computed: {
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find((item) => item.role_id === this.selectedRoleID)
            .role_name
        : "";
      return roleName;
    },
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      async handler(newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          console.log("初始登陆/切换角色", newValue);
          const {
            game_id,
            role_name,
            rid,
            server_name,
            server_id,
            access_token,
            channel,
          } = newValue;
          this.getTeamInit();
          const { protocol, host } = window.location;
          const base = `${protocol}//${host}/snail/springFestival/enter${getRandomString()}`;
          const baseUrl = new URL(base);
          baseUrl.searchParams.set("friend_id", this.activeInfo.team.team_code);
          if (this.download_id) {
            baseUrl.searchParams.set("download_id", this.download_id);
          }
          this.teamShareLink = baseUrl.toString();
          this.initTeamShareData();
          const login_access_token = localStorage.getItem("mnzt_token");
          this.isActiveAppointment =
            this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS;
          const qcJumpAuth = new QCJumpAuthPlugin({ gameId: game_id || 39 });
          const url = await qcJumpAuth.generateLoginFreeUrl({
            gameId: game_id || 39,
            flag: "pay-web",
            accessToken: access_token ? access_token : login_access_token,
            extraParams: {
              role_id: rid,
              role_name,
              server_id,
              server_name,
              os: channel,
            },
          });
          if (url) {
            this.rechargeUrl = url;
          }
        }
      },
    },
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum("马年专题_组队页");
        }
      },
    },
  },
  methods: {
    // 事件委托
    handleGlobalClick(e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute("data-snail-report-name")) {
          const reportName = el.getAttribute("data-snail-report-name");
          this.logger.sum(`马年专题组队_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 初始化
    onInitData(isFirst = false) {
      onGetInitDataAPI().then((response) => {
        this.onInitDataCallback({
          ...response,
          needAccount: false,
          needReload: false,
        });
        if (response.code !== 200) {
          if (response.code == 401) {
            this.onInitDataCallback({
              ...response,
              needAccount: true,
            });
          }
          if (response.code == 403) {
            this.setUserInfo({});
          }
          !isFirst && this.onToast(response.message);
          return;
        }
        this.getTeamListData();
        this.teamScore = Number(this.activeInfo.team.team_score) || 0;
        this.scheduleCount();
        this.scoreList = this.activeInfo.team.score_list || [];
        this.packageList = this.activeInfo.team.package_list || [];
        this.canGetReward = this.activeInfo.is_reward_start;
        this.wechatLink = this.activeInfo.url_scheme;

        this.qqNumber = this.activeInfo.qq;
        this.qqLink = this.activeInfo.qq_link;
        if (this.activeInfo.team.is_has_out_news && !this.friend_id) {
          this.showPopup("teamKickOutTipShow");
        }
        // 设置welfare-list的滚动位置
        const targetElement = document.getElementsByClassName("welfare-list");
        const idx = this.packageList.findIndex(
          (item) => item._get && !item.is_get
        );
        if (targetElement[0] && idx !== -1) {
          targetElement[0].scrollTop =
            document.getElementsByClassName(`reward-item-${idx + 1}`)[0]
              .offsetTop - 10;
        }
      });
    },
    clearDate() {
      this.teamActiveInfo = {};
      this.teamList = Array.from({ length: 6 }, () => ({}));
      this.packageList = Array.from({ length: 11 }, () => ({}));
      this.memberNum = 0;
      this.roleList = [];
      this.teamScore = 0;
      this.teamTotalScore = 0;
      this.scoreList = [];
      this.selectedRoleInfo = {};
      this.teamShareImg = "";
      this.teamInvitationNum = 0;
      this.scheduleLevel = 4000;
      this.surplusCount = 17;
      this.teamShareCopy = {
        title: "",
        desc: "",
        linkText: "",
      };
      this.rechargeUrl = "https://pay.qingcigame.com/pay?gameId=39";
      const targetDate = new Date("2026/02/06 4:59:59");
      // 获取当前时间
      const currentDate = new Date();
      // 计算时间差
      const timeDifference = targetDate - currentDate;
      // 如果时间差大于0，说明在预约期，否则不在预约期
      this.isActiveAppointment = timeDifference > 0 ? true : false;
    },
    // 进度样式
    scheduleClass() {
      let className = "";
      if (this.teamScore >= 0 && this.teamScore < 5000) {
        className = "schedule1";
      } else if (this.teamScore >= 5000 && this.teamScore < 7500) {
        className = "schedule2";
      } else if (this.teamScore >= 7500 && this.teamScore < 30000) {
        className = "schedule3";
      } else if (this.teamScore >= 30000) {
        className = "schedule4";
      }
      return className;
    },
    // 进度及奖励轮次计算
    scheduleCount() {
      const rules = [
        { min: 0, max: 4000, level: 4000, count: 17 },
        { min: 4000, max: 5000, level: 5000, count: 16 },
        { min: 5000, max: 7500, level: 7500, count: 15 },
        { min: 7500, max: 10000, level: 10000, count: 14 },
        { min: 10000, max: 15000, level: 15000, count: 13 },
        { min: 15000, max: 20000, level: 20000, count: 12 },
        { min: 20000, max: 25000, level: 25000, count: 11 },
        { min: 25000, max: 30000, level: 30000, count: 10 },
        { min: 30000, max: 35000, level: 35000, count: 9 },
        { min: 35000, max: 40000, level: 40000, count: 8 },
        { min: 40000, max: 45000, level: 45000, count: 7 },
        { min: 45000, max: 50000, level: 50000, count: 6 },
        { min: 50000, max: 60000, level: 60000, count: 5 },
        { min: 60000, max: 70000, level: 70000, count: 4 },
        { min: 70000, max: 80000, level: 80000, count: 3 },
        { min: 80000, max: 90000, level: 90000, count: 2 },
        { min: 90000, max: 100000, level: 100000, count: 1 },
        { min: 100000, max: Infinity, level: 100000, count: 0 }, // 最后一个兜底
      ];

      const rule = rules.find(
        (r) => this.teamScore >= r.min && this.teamScore < r.max
      );
      if (rule) {
        this.scheduleLevel = rule.level;
        this.surplusCount = rule.count;
      }
    },
    async getTeamInit() {
      const codeID = this.code || "";
      const authCode = this.auth_code || "";
      if (this.friend_id || codeID) {
        const response = await teamInitAPI({
          friend_id: this.friend_id,
          code: codeID,
          auth_code: authCode,
        });
        if (response.code === 200) {
          const { is_my, number, is_join, team_score } = response.data.activity;
          if (is_my) {
            this.showPopup("teamJoinFailedMyselfShow");
          } else if (is_join) {
            this.showPopup("teamJoinFailedHasTeamShow");
          } else if (number === 6) {
            this.showPopup("teamJoinFailedFullStrengthShow");
          } else {
            this.teamInvitationNum = number;
            this.teamTotalScore = team_score;
            this.showPopup("teamInvitationJoinShow");
          }
        } else {
          if (this.showContent) {
            // 一开始没登录，后来登录不需要loading，直接提示
            this.onToast(response.message, 2000);
          } else {
            let hasWatchedComic = localStorage.getItem("hasWatchedComic");
            setTimeout(
              () => {
                this.onToast(response.message, 2000);
              },
              hasWatchedComic === "true" ? 3200 : 6200
            );
          }
        }
      }
    },
    // 去下载
    toDownload() {
      this.downloadApp();
    },
    goLink(url) {
      if (url === "") return;
      Indicator.open();
      setTimeout(() => {
        window.location.href = url;
        Indicator.close();
      }, 200);
    },
    // 跳转到首页
    toIndex(popupName) {
      this.closePopup(popupName);
      // const { protocol, host } = window.location;
      // window.location.href = `${protocol}//${host}/snail/midAutumn/anniversary${getRandomString()}`;
      this.changeTab({ id: "1", label: "新服预约", path: "anniversary" });
    },
    triggerEffect() {
      if (this.isEgg) {
        this.isEgg = false;
        this.player.stop();
      }
      this.isEgg = true;
      this.player.play();
      this.clickEggCount = this.clickEggCount + 1;
      if (this.clickEggCount === 33 || this.clickEggCount === 66) {
        this.onToast("棋子抖了一下...");
      }
      if (this.clickEggCount === 99) {
        this.showPopup("easterEggShow");
      }
      this.player.on("end", () => {
        console.log("APNG 播放结束！");
        this.isEgg = false;
      });
    },
    async initAPNG() {
      // 1. 获取 Canvas 上下文
      const canvas = this.$refs.apngCanvas;
      const ctx = canvas.getContext("2d");

      // 2. Fetch 获取图片二进制数据
      // 注意：如果是本地图片，需确保开发服务器支持或放在 public 目录下
      const response = await fetch(this.imgSrc);
      const buffer = await response.arrayBuffer();

      // 3. 解析 APNG
      const apng = await parseAPNG(buffer);

      // 4. 创建播放器实例
      this.player = await apng.getPlayer(ctx);

      // 5. 监听播放结束事件 (关键步骤)
      this.player.on("end", () => {
        console.log("APNG 播放结束！");
      });

      // 6. 开始播放
      // this.player.play();
    },
    showLogDialog() {
      if (!this.userInfo.user_id) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.scoreList.length === 0) {
        this.showPopup("teamNotPointsRecordShow");
      } else {
        this.showPopup("teamPointsRecordShow");
      }
    },
    showLogin() {
      if (!this.userInfo.user_id) {
        this.changeLoginPopup(true);
        return;
      }
    },
    openFindTeamShow() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum("马年专题组队_寻找搭子按钮");
      this.showPopup("findTeamShow");
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.closePopup("findTeamShow");

        this.showPopup("qqGroupShow");
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat() {
      window.location.href = this.wechatLink;
    },
    initTeamShareData() {
      try {
        // 生成一个随机数，用于判断随机使用两种文案中的一种
        // const randomNum = Math.random();
        this.teamShareCopy = {
          title: "【最强蜗牛】蜗也要胜天半子！",
          desc: "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
          linkText:
            "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
        };

        this.qrcode("team-qrcode", `${this.teamShareLink}`);
        this.$nextTick(() => {
          this.generateTeamShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log("组队分享初始化失败", err);
      }
    },
    // 生成二维码
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: "#eee4d4",
        colorLight: "#c5a790",
      });
    },
    onCopy(id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on("success", (e) => {
        this.onToast(id === "thank-words" ? "密令复制成功" : "复制成功");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToast("复制失败");
      });
    },
    generateTeamShareImage(successCallback, failedCallback) {
      generateCanvasImage(this.$refs.teamImageDom)
        .then((canvas) => {
          this.teamShareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          successCallback && successCallback();
        })
        .catch((err) => {
          failedCallback && failedCallback();
          console.log("组队分享图生成失败", err.message);
        });
    },
    onTeamShare() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?friend_id=${this.activeInfo.team.team_code}`;
        window.history.replaceState(null, "", newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.teamShareLink,
          title: this.teamShareCopy.title,
          imgUrl:
            "https://download4.qcplay.com/qcgame-api/mDG0FvkV2xtEH4cfyEIt8MMcWF6CxRo6IdrDiHzx.png",
          desc: this.teamShareCopy.desc,
        });
        this.teamWechatShareShow = true;
        this.logger.sum("马年专题组队_邀请组队次数");
      } else {
        this.onPreventShow();
        this.generateTeamShareImage(
          () => {
            this.onPreventClose();
            this.teamNotWechatShareShow = true;
          },
          () => {
            this.onPreventClose();
          }
        );
      }
    },
    closeWechatShare(popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, "", window.location.pathname);
    },
    getTeamListData() {
      let teamList = this.activeInfo.team.team_list || [];
      teamList.forEach((item) => {
        const { y, m, d, h, status } = item;
        if (y) {
          item.lastTime = `${y}年前`;
        } else if (m) {
          item.lastTime = `${m}月前`;
        } else if (d) {
          item.lastTime = `${d}天前`;
        } else {
          item.lastTime = "今天";
        }
        item.is_myself = this.userInfo.user_id === item.id;
        item.is_kick_out =
          this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS &&
          this.activeInfo.team.is_first &&
          !item.is_myself;
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 6) {
        const fillCount = 6 - teamList.length;
        const fillArray = Array.from({ length: fillCount }, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team.team_list.length;
      if (
        this.activeInfo.team.team_list.length == 6 &&
        localStorage.getItem("isShowFullCommission") !== "true"
      ) {
        this.showPopup("fullCommissionShow");
      }
    },
    // 是否显示过满员弹窗了
    closeShowFullCommission() {
      localStorage.setItem("isShowFullCommission", "true");
      this.closePopup("fullCommissionShow");
    },
    // 查看我的组队
    toMyTeamByTeam() {
      this.closePopup("teamJoinFailedHasTeamShow");
      // 锁定到页面召回板块
      this.scrollIntoTeamBox();
    },
    scrollIntoTeamBox() {
      const targetElement = document.getElementById("team-consumption-box");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    },
    readPlayerInfo(id) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const curPlayerInfo = this.teamList.find((item) => item.id === id);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      console.log("curPlayerInfo", this.curPlayerInfo);
      this.showPopup("teamPlayerInfoShow");
    },
    // 踢出队伍
    async onKickOut() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamKickAPI({ id: this.curPlayerInfo.id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast("已踢出队伍");
        this.closePopup("teamPlayerInfoShow");
        this.onInitData();
        this.logger.sum("马年专题组队_实际踢出队伍");
      }
      this.onPreventClose();
    },
    // 跳转回归活动
    regressToActivity() {
      if (this.userInfo.user_id === undefined) {
        const newDate = new Date().getTime();
        const timestamp = new Date("2026/02/13 05:00:00").getTime();
        if (timestamp > newDate) {
          this.onToast("活动尚未开始，敬请期待！");
          return;
        }
      }
      if (!this.activeInfo.invite.is_start) {
        this.onToast("活动尚未开始，敬请期待！");
        return;
      }
      this.logger.sum("马年专题组队_挚友回归");
      window.location.href =
        "https://h5.qingcigame.com/snail/springFestivalActiveRecall/enter";
    },
    // 跳转花灯活动
    lightToActivity() {
      if (this.userInfo.user_id === undefined) {
        const newDate = new Date().getTime();
        const timestamp = new Date("2026/02/13 05:00:00").getTime();
        if (timestamp > newDate) {
          this.onToast("活动尚未开始，敬请期待！");
          return;
        }
      }
      if (!this.activeInfo.card.is_start) {
        this.onToast("活动尚未开始，敬请期待！");
        return;
      }
      this.logger.sum("马年专题组队_新春灯火会");
      window.location.href =
        "https://h5.qingcigame.com/snail/springFestivalActiveLight/enter";
    },
    // 跳转到充值网站
    toRecharge() {
      window.location.href = this.rechargeUrl;
    },
    async onExitTeam() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamExitAPI();
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.closePopup("teamExitShow");
        this.logger.sum("马年专题组队_实际退出队伍");
        this.onToast("退出成功");
        this.onInitData();
      }
      this.onPreventClose();
    },
    async rejectJoinTeam() {
      this.toIndex("teamInvitationJoinShow");
    },
    async agreeJoinTeam() {
      const codeID = this.code || "";
      const authCode = this.auth_code || "";
      if (this.needInvitationConfirm) {
        this.closePopup("teamInvitationJoinShow");
        this.showPopup("teamInvitationConfirmShow");
        this.needInvitationConfirm = false;
        return;
      }
      this.onPreventShow();
      const response = await teamJoinAPI({
        friend_id: this.friend_id,
        code: codeID,
        auth_code: authCode,
      });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast("入队成功");
      }
      this.needInvitationConfirm = true;
      this.onPreventClose();
      this.closePopup("teamInvitationJoinShow");
      this.closePopup("teamInvitationConfirmShow");
      this.onInitData();
    },
    // 领取奖励
    async onReward() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.userInfo.rid) {
        this.onBindRolePopup();
        return;
      }
      this.onPreventShow();
      const response = await teamRewardAPI();
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast("领取成功");
        this.onInitData();
      }
      this.onPreventClose();
    },
    // 角色选弹窗
    async onBindRolePopup() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (!this.canGetReward) {
        this.onToast("暂未开启，9月26日8:00再来吧");
        return;
      }
      // 未加入队伍的
      if (this.activeInfo.team.team_list.length === 0) {
        this.onToast("很抱歉,你还没有加入队伍!");
        return;
      }

      // 获取角色信息 打开角色选择弹窗
      const roleResponse = await GetRoleList({
        account: this.userInfo.account,
        page_id: PAGE_ID[this.gameName],
        app_id: APP_ID[this.gameName],
      });

      if (Number(roleResponse.code) === 200) {
        // 正式服ID
        const serverIds = GAME_AREA[this.gameName][1].id;
        let data = roleResponse.data[serverIds] || [];
        this.roleList = data["android"];
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      }
    },
    // 角色信息二次确认弹窗
    reConfirmBindRolePopup() {
      if (this.selectedRoleID === "") {
        return this.onToast("请选择区组");
      }
      let selectInfo = this.roleList.find(
        (item) => item.role_id === this.selectedRoleID
      );
      selectInfo.type = "android";
      selectInfo.dist = APP_ID[this.gameName];
      selectInfo.extra = JSON.stringify(selectInfo.extra);
      this.selectedRoleInfo = selectInfo;
      this.closePopup("snailRoleSelect");
      this.showPopup("teamBindRoleConfirmShow");
    },
    closeReConfirmBindRole() {
      this.selectedRoleInfo = {};
      this.closePopup("teamBindRoleConfirmShow");
    },
    confirmBindRole() {
      this.onPreventShow();
      teamRewardAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.closePopup("teamBindRoleConfirmShow");
            this.onToast("绑定成功");
            this.onInitData();
          } else {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          this.onPreventClose();
        });
    },
    loginSuccess() {
      // this.onInitData();
    },
    loginCallback(response) {
      localStorage.setItem("mnzt_token", response.data.access_token);
    },
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${
        minutes >= 10 ? minutes : "0" + minutes
      }:${seconds >= 10 ? seconds : "0" + seconds}`;
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
      this.onInitData();
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      // this.changeOsPopup(false);
    },
    noRole() {
      this.setUserInfo({});
      // this.changeOsPopup(false);
    },
    // TAG: 其他简易封装的方法
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: "toasts",
      };
      if (!config) {
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      if (name == "findTeamShow") {
        if (this.userInfo.user_id === undefined) {
          this.changeLoginPopup(true);
          return;
        }
      }
      this[name] = true;
      if (name == "teamExitShow") {
        this.logger.sum("马年专题组队_退出队伍弹窗");
      } else if (name == "teamPlayerInfoShow") {
        this.logger.sum("马年专题组队_请离队伍弹窗");
      }
    },
    closePopup(name) {
      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/springFestival/index/index.vue